import React, { useEffect, useState } from 'react';
import { Grid, IconButton } from '@mui/material';
import { useDispatch } from 'react-redux/es/hooks/useDispatch';
import CustomModal from '../../Common/CustomModal';
import DeleteUserGroupModal from '../DeleteUserGroupModal/DeleteUserGroupModal';
import { IUserGroup, userGroupsActions } from '../../../redux/userGroups/userGroupsSlice';
import { RootState } from '../../../redux/rootReducer';
import { useAppSelector } from '../../../redux/hooks';
import CreateUpdateUserGroupModal from '../CreateUpdateUserGroupModal/CreateUpdateUserGroupModal';

function RowActions({ row }: { row: IUserGroup }) {
  const dispatch = useDispatch();

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const { deleteUserGroupSuccess, updateUserGroupSuccess } = useAppSelector(
    (state: RootState) => state.userGroups
  );

  useEffect(() => {
    if (deleteUserGroupSuccess) {
      setDeleteModalOpen(false);
      dispatch(userGroupsActions.resetDeleteUserGroupSuccess());
    }
  }, [deleteUserGroupSuccess]);

  useEffect(() => {
    if (updateUserGroupSuccess) {
      setUpdateModalOpen(false);
      dispatch(userGroupsActions.resetUpdateUserGroupSuccess());
    }
  }, [updateUserGroupSuccess]);

  return (
    <Grid container gap="12px">
      <img
        src="/assets/icons/pen-bold.svg"
        alt="img"
        role="presentation"
        style={{ cursor: 'pointer' }}
        onClick={() => {
          setUpdateModalOpen(true);
        }}
      />
      <IconButton
        aria-label="delete"
        onClick={() => {
          setDeleteModalOpen(true);
        }}
        disabled={row.clients.length + row.coaches.length > 0}
      >
        <img
          src={
            row.clients.length + row.coaches.length > 0
              ? '/assets/icons/trash-bin-disabled.svg'
              : '/assets/icons/trash-bin.svg'
          }
          alt="img"
          role="presentation"
          // style={{ cursor: 'pointer' }}
        />
      </IconButton>

      <CustomModal isOpen={deleteModalOpen} width={391}>
        <DeleteUserGroupModal
          handleDismiss={() => {
            setDeleteModalOpen(false);
          }}
          id={row.id}
          groupName={row.name}
        />
      </CustomModal>
      <CreateUpdateUserGroupModal
        isOpen={updateModalOpen}
        isCreateGroup={false}
        modulesWithPermissions={row.modules}
        initialGroupName={row.name}
        id={row.id}
        handleDismiss={() => {
          setUpdateModalOpen(false);
        }}
      />
    </Grid>
  );
}

export default RowActions;
